module.exports = __webpack_public_path__ + "img/8.6ad74572.png";